import { useCallback } from "react";
import { trpc } from "../../../lib/api/trpc";
import { UpdateUserInput } from "@shared/schemas";

/**
 * Hook for updating an existing user
 */
export const useUpdateUser = () => {
  // Get the trpc context for revalidating queries
  // @ts-ignore - Type checking for trpc.useContext
  const utils = trpc.useContext();

  // Update user mutation
  // @ts-ignore - Type checking for trpc.user property
  const {
    // mutate, // Commented out as it's not used
    mutateAsync,
    isLoading,
    isError,
    error,
    isSuccess,
    reset,
  } = trpc.user.updateUser.useMutation({
    onSuccess: (_, variables) => {
      // Invalidate the specific user query and the users list
      // @ts-ignore - Type checking for utils.user property
      utils.user.getUserById.invalidate({ id: variables.id });
      // @ts-ignore - Type checking for utils.user property
      utils.user.getUsers.invalidate();
    },
  });

  // Function to update a user with better error handling
  const updateUser = useCallback(
    async (userData: UpdateUserInput) => {
      try {
        const result = await mutateAsync(userData);
        return { success: true, data: result };
      } catch (err: any) {
        return {
          success: false,
          error: err?.message || "Failed to update user",
        };
      }
    },
    [mutateAsync],
  );

  return {
    updateUser,
    isLoading,
    isError,
    error,
    isSuccess,
    reset,
  };
};
